import { Typography } from '@mui/material'
import type { FileType } from './FileIcon'

interface FileTypeLabelProps {
  fileType: FileType
}

export const FileTypeLabel = ({ fileType }: FileTypeLabelProps) => (
  <Typography variant="caption" color="text.secondary">
    {fileType.toUpperCase()}
  </Typography>
)
